import React from 'react';
import {
  TextField,
} from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import { makeStyles, Theme } from '@material-ui/core/styles';
import {
  devePermitirTeclaNumerica,
  filtrarValorNumerico,
} from '../../../../utils/numeric-input';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#264259',
      },
    },
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
  input: {
    color: theme.palette.primary.main,
  },
}));

export default function TextNumber(props: TextFieldProps): JSX.Element {
  const classes = useStyles();
  const { required, inputProps, InputLabelProps, ...rest } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const filteredValue = filtrarValorNumerico(event.target.value);
    const newEvent = {
      ...event,
      target: {
        ...event.target,
        value: filteredValue,
      },
    } as React.ChangeEvent<HTMLInputElement>;
    if (props.onChange) {
      props.onChange(newEvent);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!devePermitirTeclaNumerica(event)) {
      event.preventDefault();
    }
  };

  return (
    <TextField
      InputProps={{
        className: classes.input,
        onKeyDown: handleKeyDown,
      }}
      className={classes.textField}
      type="text"
      inputMode="numeric"
      variant="outlined"
      fullWidth
      {...rest}
      onChange={handleChange}
      InputLabelProps={{ ...InputLabelProps, required: Boolean(required) }}
      inputProps={{ ...inputProps, required: undefined }}
    />
  );
}
